import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';

import { t } from '../../config/i18n';
import { Defaults, px, Spacer, TextEx } from '../common';
import { LikeIcon } from '../fastdeal/Icons';
import IconEx from './IconEx';

export const UserDeals = ({
  deals,
  left,
  width,
  size,
  hint,
  iconPath = '/ico/top/profile/person.svg',
  weight = 400,
  icon,
}: {
  deals?: number;
  left?;
  width?;
  size: number | string;
  hint?: string;
  weight?: number | string;
  iconPath?: string;
  icon?: ReactElement;
}) => {
  if (deals === undefined) {
    return <></>;
  }
  return (
    <Root left={left} width={width} title={hint}>
      {icon ? icon : <IconEx src={iconPath} size={size} />}
      <TextEx left={'0.5rem'} size={size} weight={weight}>
        {deals}
      </TextEx>
    </Root>
  );
};

export const UserRating = ({
  rating,
  left,
  width,
  size,
  hint,
  iconPath = '/ico/top/profile/diamond.svg',
  weight = 400,
  icon,
}: {
  rating?: number;
  left?;
  width?;
  size: number | string;
  hint?: string;
  weight?: number | string;
  iconPath?: string;
  icon?: ReactElement;
}) => {
  if (rating === undefined) {
    return <></>;
  }
  return (
    <Root left={left} width={width} title={hint}>
      {icon ? icon : <IconEx src={iconPath} size={size} />}
      <TextEx left={'0.5rem'} size={size} weight={weight}>
        {rating}
      </TextEx>
    </Root>
  );
};

export const UserDealsRating = ({
  deals,
  rating,
  left,
  width,
  size,
}: {
  deals?: number;
  rating?: number;
  left?;
  width?;
  size: number | string;
}) => (
  <Root left={left}>
    <UserDeals deals={deals} size={size} width={width} hint={t('user-profile.deals')} />
    {deals !== undefined && rating !== undefined ? <Spacer width={'1vw'} /> : undefined}
    <UserRating
      rating={rating}
      size={size}
      width={width}
      hint={t('user-profile.rating')}
    />
  </Root>
);

export const UserReviews = ({
  likes,
  dislikes,
  left,
  size,
}: {
  likes?: number;
  dislikes?: number;
  left?;
  size: number | string;
}) => (
  <Root left={left}>
    {likes !== undefined ? (
      <>
        <LikeIcon size={size} fill={Defaults.fontColor} />
        <TextEx left={'0.3125rem'} size={size}>
          {likes}
        </TextEx>
      </>
    ) : undefined}
    {likes !== undefined && dislikes !== undefined ? <Spacer width={'1vw'} /> : undefined}
    {dislikes !== undefined ? (
      <>
        <LikeIcon
          size={size}
          fill={Defaults.fontColor}
          style={{ transform: 'scaleY(-1)' }}
        />
        <TextEx left={'0.3125rem'} size={size}>
          {dislikes}
        </TextEx>
      </>
    ) : undefined}
  </Root>
);

export const UserLikesDislikes = ({
  likes = 0,
  dislikes = 0,
  left,
  size,
}: {
  likes?: number;
  dislikes?: number;
  left?;
  size: number | string;
}) => (
  <Root left={left}>
    {likes >= 0 && (
      <>
        <LikeIcon size={size} fill={Defaults.fontColor} />
        <TextEx left={'0.5rem'} size={size} weight={500}>
          {likes}
        </TextEx>
      </>
    )}
    {likes >= 0 && dislikes >= 0 && (
      <TextEx left={'0.5rem'} right={'0.5rem'} size={size} weight={500}>
        /
      </TextEx>
    )}
    {dislikes >= 0 && (
      <>
        <TextEx right={'0.5rem'} size={size} weight={500}>
          {dislikes}
        </TextEx>
        <LikeIcon
          size={size}
          fill={Defaults.fontColor}
          style={{ transform: 'scaleY(-1)' }}
        />
      </>
    )}
  </Root>
);

const Root = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: ${(props) => px(props.left)};
  ${(props) => (props.width ? `width: ${px(props.width)};` : '')}
`;
const LikeIconRoot = styled.svg`
  width: ${(props) => px(props.size)};
  height: ${(props) => px(props.size)};
  &.flip {
    transform: scaleY(-1);
    margin-top: -2px;
  }
`;
